import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { timeFormat } from '../../../common/utils';

const Root = styled(Dialog)({
    width: '100%',
    '& .MuiGrid-item': {
        padding: '4px 12px'
    },
    '& .table': {
        width: '1000px',
        borderCollapse: 'collapse',
        border: '1px solid #EDEDED',
        '& th': {
            height: '35px',
            backgroundColor: '#EDEDED',
            border: '1px solid #EDEDED'
        },
        '& td': {
            height: '35px',
            border: '1px solid #EDEDED'
        },
        '& .noBorder': {
            border: 'none',
        },
        '& .addBtn': {
            verticalAlign: 'top',
        },
        '& .bgTransparent': {
            backgroundColor: 'transparent',
        },
    },
    '& .color-w': {
        color: '#fff',
    },
    '& .bg-w': {
        backgroundColor: '#fff',
    },
    '& .bg-b': {
        backgroundColor: '#469ae1',
    },
    '& .mr-10': {
        marginRight: "10px"
    },
    '& .mk-10': {
        marginLeft: "10px"
    },
})
class UserTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            rateUserId: null,
            legalData: [],
            chooseAll: false,
            chooseNum: 0
        }
        this.handleClose = this.handleClose.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleCheck = this.handleCheck.bind(this);
        this.handleCheckAll = this.handleCheckAll.bind(this);
    }
    render() {
        const {
            open,
            legalData,
            chooseNum,
            chooseAll,
        } = this.state;
        const chooseView = () => {
            if (chooseNum > 0) {
                return <div style={{ marginLeft: "17px" }}>{chooseNum} selected</div>
            }
        }
        return (
            <Root maxWidth={false} open={open}>
                <DialogTitle id="form-dialog-title">
                    <div>Select the user whose rate needs to be modified</div>
                </DialogTitle>
                <DialogContent dividers spacing={3}>
                    <table className="table" cellPadding={10}>
                        <thead>
                            <tr>
                                <th width="5%">
                                    <Checkbox
                                        checked={chooseAll}
                                        color="primary"
                                        onChange={this.handleCheckAll}
                                    />
                                </th>
                                <th width="8%">Date</th>
                                <th width="8%">Legal Item</th>
                                <th width="20%">By</th>
                                <th width="22%">Description</th>
                                <th width="8%">Hours</th>
                                <th width="8%">Rate</th>
                                <th width="10%">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {legalData.map((row, index) => (
                                <tr key={index}>
                                    <td align="center">
                                        <Checkbox
                                            checked={row.check}
                                            color="primary"
                                            onChange={e => this.handleCheck(e, index)}
                                        />
                                    </td>
                                    <td align="center">{timeFormat(row.date)}</td>
                                    <td align="center">{this.changeType(row.type)}</td>
                                    <td align="center">{this.handlerName(row)}</td>
                                    <td align="center">{row.description}</td>
                                    <td align="center">{row.hours}</td>
                                    <td align="center">{row.rate}</td>
                                    <td align="center">{row.amount}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </DialogContent>
                <DialogActions>
                    <div className="f">
                        {chooseView()}
                    </div>
                    <Button className="mr-10" variant="contained" onClick={this.handleClose}>Close</Button>
                    <Button disabled={!(chooseNum > 0)} variant="contained" color="primary" onClick={this.handleSave}>SAVE</Button>
                </DialogActions>
            </Root>
        )
    }
    componentDidMount() {
    }
    componentDidUpdate(prevProps) {
        const {
            open,
            legalData,
            rateUserId,
        } = this.props;
        if (prevProps.open !== open) {
            if (open) {
                this.initEditor(legalData, rateUserId);
            } else {
                this.setState({
                    open
                });
            }
        }
    }
    initEditor(legalData, rateUserId) {
        let newLegalData = [];
        for (const obj of legalData) {
            obj.check = false;
            if (obj.handler.id === rateUserId) {
                newLegalData.push(obj);
            }
        }
        this.setState({
            open: true,
            legalData: newLegalData,
            rateUserId
        });
    }
    handleSave(e) {
        const { legalData } = this.state;
        const { rate } = this.props;
        this.props.onClose(legalData, rate);
        this.clearState();
    }
    handleClose(e) {
        this.props.onClose();
        this.clearState();
    }
    clearState() {
        this.setState({
            chooseAll: false,
            chooseNum: 0
        })
    }
    changeType(str) {
        if (str === "legal_fee") return "legal fee";
        return str;
    }
    handlerName(row) {
        if (!row) return "";
        const handler = row.handler,
            firstName = handler.first_name ? handler.first_name : "",
            lastName = handler.last_name ? handler.last_name : "";
        return firstName + " " + lastName;
    }
    handleCheck(e, index) {
        const { legalData } = this.state;
        const rateObj = legalData[index];
        rateObj.check = !rateObj.check;
        this.setState({
            legalData
        }, () => {
            this.checkAll();
        })
    }
    handleCheckAll() {
        const { legalData } = this.state;
        let chooseAll = this.state.chooseAll;
        chooseAll = !chooseAll;
        let chooseNum = 0;
        for (const obj of legalData) {
            if (chooseAll) {
                chooseNum++;
                obj.check = true;
            } else {
                chooseNum = 0;
                obj.check = false;
            }
        }
        this.setState({
            legalData,
            chooseAll,
            chooseNum
        })
    }
    checkAll() {
        const { legalData } = this.state;
        let chooseAll = true;
        let chooseNum = 0;
        for (const obj of legalData) {
            if (obj.check === false) {
                chooseAll = false;
            } else {
                chooseNum++;
            }
        }
        this.setState({
            chooseAll,
            chooseNum
        })
    }
}

export default UserTable;